import React from "react";
import styled from "styled-components";
import { PostContainer, Content } from "./Shared";
import PostFooter from "../PostFooter/PostFooter";
import Picture from "components/Picture";

const StyledPicture = styled(Picture)`
  img {
    width: 100%;
    height: auto;
    border-radius: 25px;
  }
`;

export default function PhotoPost(props) {
  const renderPostFooter = () =>
    props.activeAudience || props.showPostFooter ? (
      <PostFooter {...props} />
    ) : null;

  return (
    <PostContainer {...props}>
      <Content noPadding>
        <StyledPicture
          image={props.image || props.content}
          imageAlt={props.imageAlt}
          width={500}
        />
      </Content>
      {renderPostFooter()}
    </PostContainer>
  );
}
